
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Simplemde from './Simplemde.vue'

@Component({
  components: {
    Simplemde
  }
})
export default class CommentCreation extends Vue {
  @Prop({ default: true })
  showCommentForm: boolean

  @Prop({ required: true })
  createComment: (newComment: string) => Promise<void>

  @Prop({ required: true })
  onCancel: () => Promise<void>

  @Prop({ required: true })
  onOpen: () => Promise<void>

  newComment = ''

  async onCreateComment() {
    await this.createComment(this.newComment)

    this.newComment = ''
  }
}
